/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.08.02 at 18:54
 */
import { TranslatorFactory } from './TranslatorFactory';
var TranslatorPlugin = /** @class */ (function () {
    function TranslatorPlugin(options) {
        this._options = options !== null && options !== void 0 ? options : {};
    }
    /**
     * @hidden
     */
    TranslatorPlugin.prototype.initialized = function (app) {
        var _this = this;
        app.di.setFactory('translatorFactory', function () { return new TranslatorFactory(_this._options); })
            .setFactory('translator', function (di) { return di.translatorFactory.requireGlobalTranslator(); });
    };
    /**
     * @hidden
     */
    TranslatorPlugin.prototype.extendBits = function (inject) {
        inject('t', function (key, args, options) {
            return this.$translator.translate(key, args, options);
        });
        inject('translator', {
            callback: function () {
                var _a;
                if (!this.$_translator) {
                    this.$_translator = this.$di.translatorFactory.requireTranslator((_a = this.$context.mount.el) !== null && _a !== void 0 ? _a : document.documentElement);
                }
                return this.$_translator;
            },
            destructor: function () {
                delete this.$_translator;
            },
            getter: true
        });
    };
    return TranslatorPlugin;
}());
export { TranslatorPlugin };
//# sourceMappingURL=TranslatorPlugin.js.map